import { css, UpdatingElement } from 'lit-element';
import { addDocStyle } from '../../common/style';
import './ki-list-item';
import './ki-list-item-group';
import PropertyDefaultValue from '../../common/PropertyDefaultValue';
import Mix from '../../common/Mix';

export default class KiList extends Mix(UpdatingElement, PropertyDefaultValue) {
  // language=CSS
  static styles = css`
    ki-list {
      display: block;
      --ki-list-indent: 12px;
    }

    ki-list-item {
      display: block;
      position: relative;
      padding: 12px;
    }

    ki-list-item:hover,
    ki-list-item:focus {
      color: var(--theme-color, #0056a0);
      background-color: #eeeeee;
    }

    ki-list-item.selected {
      background-color: var(--theme-color, #0056a0);
      color: var(--theme-text-color, white);
    }

    ki-list-item-group {
      display: block;
      position: relative;
    }
    ki-list-item-group .label {
      padding: 12px 0;
    }

    ki-list-item-group .label:hover,
    ki-list-item-group .label:focus {
      color: var(--theme-color, #0056a0);
      background-color: #eeeeee;
    }

    ki-list-item-group .children {
      display: block;
      overflow: hidden;
      height: auto;
    }
    ki-list-item-group.folded .children {
      max-height: 0px;
    }
  `;

  connectedCallback() {
    addDocStyle({ content: KiList.styles, target: this });
  }
}

customElements.define('ki-list', KiList);
